var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 57,
    viewBox: "0 0 63 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M22.9352 4.94445C26.7415 -1.64814 36.2571 -1.64815 40.0633 4.94444L61.4734 42.0278C65.2796 48.6204 60.5218 56.8611 52.9093 56.8611H10.0892C2.47673 56.8611 -2.28108 48.6204 1.52516 42.0278L22.9352 4.94445Z",
    fill: "#EBBA45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M29.9728 35.031H33.6912L34.856 13.751H28.808L29.9728 35.031ZM31.8096 39.063C30.0176 39.063 28.584 40.4966 28.584 42.2886C28.584 44.0806 30.0176 45.559 31.8096 45.559C33.6016 45.559 35.08 44.0806 35.08 42.2886C35.08 40.4966 33.6016 39.063 31.8096 39.063Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.29f19ee0fd0f30b35c198039177e417a.svg";
export { ForwardRef as ReactComponent };